var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_32px",
    "data-name": "32px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Combined_Shape",
    "data-name": "Combined Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M.137,9.445H.9A7.25,7.25,0,1,0,.75,8c0,.177.014.352.027.527H.027C.015,8.352,0,8.178,0,8A8.032,8.032,0,1,1,.137,9.445Zm7.412,2.322a.54.54,0,1,1,.54.54A.54.54,0,0,1,7.549,11.767Zm.145-1.354v-2.2a.375.375,0,0,1,.375-.375A1.748,1.748,0,1,0,6.322,6.089h-.75A2.5,2.5,0,1,1,8.445,8.558v1.855Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-3",
    "data-name": "Combined Shape",
    d: "M.137,9.445H.9A7.25,7.25,0,1,0,.75,8c0,.177.014.352.027.527H.027C.015,8.352,0,8.178,0,8A8.032,8.032,0,1,1,.137,9.445Zm7.412,2.322a.54.54,0,1,1,.54.54A.54.54,0,0,1,7.549,11.767Zm.145-1.354v-2.2a.375.375,0,0,1,.375-.375A1.748,1.748,0,1,0,6.322,6.089h-.75A2.5,2.5,0,1,1,8.445,8.558v1.855Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-4",
    "data-name": "Combined Shape",
    d: "M.137,9.445H.9A7.25,7.25,0,1,0,.75,8c0,.177.014.352.027.527H.027C.015,8.352,0,8.178,0,8A8.032,8.032,0,1,1,.137,9.445Zm7.412,2.322a.54.54,0,1,1,.54.54A.54.54,0,0,1,7.549,11.767Zm.145-1.354v-2.2a.375.375,0,0,1,.375-.375A1.748,1.748,0,1,0,6.322,6.089h-.75A2.5,2.5,0,1,1,8.445,8.558v1.855Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-5",
    "data-name": "Combined Shape",
    d: "M.137,9.445H.9A7.25,7.25,0,1,0,.75,8c0,.177.014.352.027.527H.027C.015,8.352,0,8.178,0,8A8.032,8.032,0,1,1,.137,9.445Zm7.412,2.322a.54.54,0,1,1,.54.54A.54.54,0,0,1,7.549,11.767Zm.145-1.354v-2.2a.375.375,0,0,1,.375-.375A1.748,1.748,0,1,0,6.322,6.089h-.75A2.5,2.5,0,1,1,8.445,8.558v1.855Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-6",
    "data-name": "Combined Shape",
    d: "M.137,9.445H.9A7.25,7.25,0,1,0,.75,8c0,.177.014.352.027.527H.027C.015,8.352,0,8.178,0,8A8.032,8.032,0,1,1,.137,9.445Zm7.412,2.322a.54.54,0,1,1,.54.54A.54.54,0,0,1,7.549,11.767Zm.145-1.354v-2.2a.375.375,0,0,1,.375-.375A1.748,1.748,0,1,0,6.322,6.089h-.75A2.5,2.5,0,1,1,8.445,8.558v1.855Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-7",
    "data-name": "Combined Shape",
    d: "M.137,9.445H.9A7.248,7.248,0,1,0,.75,8c0,.177.014.352.027.526H.026C.015,8.352,0,8.177,0,8A8.032,8.032,0,1,1,.137,9.445Zm7.412,2.323a.54.54,0,1,1,.54.54A.54.54,0,0,1,7.549,11.767ZM7.7,10.413v-2.2a.375.375,0,0,1,.374-.375A1.748,1.748,0,1,0,6.322,6.089h-.75a2.5,2.5,0,1,1,2.873,2.47v1.855Z",
    fill: "#1a1446"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1aed3ca8789454ae2c3484f98bbdcf0b.svg";
export { ForwardRef as ReactComponent };